import dayjs from "dayjs";

export const dateFormat = (date) => {
  //input

  return date ? dayjs(date).format("YYYY/MM/DD hh:mm") : null;
};

//url 반환 함수
export const getHostUrl = () => {
  let hostUrl = "https://" + window.location.host;

  if (hostUrl.toLowerCase().includes("localhost")){
    hostUrl = "https://opic.airsoundtest.com";
  }

  return hostUrl;
}
